import React, {useEffect, useRef,useState } from "react"; 
import {getAllRoles,getAllAcls} from '../../../Services/rolesServices'
import Checkbox from './checkBox';
import Loader from "../../common/loader";
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");
function ischecked(permissions,id){
  const exists =   permissions.find(item => item.role_id === id)!== undefined;                  
  if(exists){
    return true;
  }
  return false;
}

function AccessControl() {
  const tableRef = useRef(null); 
  const [roleData, setRoleData] = useState([]);
  const [acl, setAcl] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(  () => {  
      const fetchData = async () => {
        try { 
          const response = await getAllRoles();  
          await setRoleData(response.data);
          const acldata = await getAllAcls();  
          await setAcl(acldata.data); 
          setIsLoading(false)
        } catch (error) {
          // Handle errors
          // setError(error);
        } 
      }; 
      fetchData();
  }, []);
   
  useEffect(  () => {  
    if(!checkPermissions('access_control_page') || !checkPermissions('settings_navigation')){ 
          navigate('/')
        }
    if(!isLoading){
      $(tableRef.current).DataTable()
    }
}, [isLoading]); 
 

  return (
    <div>
     <main id="main" className="main">
     
      <div className="pagetitle">
        <h1>Access Control</h1> 
      </div> 
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">   
                
            {isLoading?<Loader />:<table
                  ref={tableRef}
                   className="table table-striped" id="acltable">
                  <thead>
                    <tr id="trheader"> 
                    {roleData.length>0?<th scope="col">Name</th>:''}    
                      {roleData?.map((data, idx) => ( 
                        <th scope="col" key={data.id} >{data.role}</th> 
                       ))}
                    </tr>
                  </thead>
                  <tbody id="acltablesec"> 
                  {acl?.map((aclData, idx) => (  
                        <tr kry={aclData.id}> 
                        <td scope="col">{aclData.name}</td>  
                        {roleData?.map((data, idx) => (  
                          <td className="tac">
                            <Checkbox  
                            isSelected ={ischecked(aclData.systemUserPermissions,data.id)} 
                            roleId={data.id}
                            permissionId={aclData.id} />  
                            </td>
                       ))}
                      </tr>
                    ))
                    
                    }
                  </tbody>
                </table>}  
                
              </div>
            </div>
          </div>
        </div>
      </section> 
      </main>
    </div>
  );
}
export default AccessControl;
